import React from 'react';
import { SectionWrapper } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const WhatYouGetSection = () => {
  const items = ['El Protocolo "Hombre Apagado No Más" en formato PDF premium (65+ páginas).', 'La Guía de los 12 Alimentos de Alto Impacto Masculino.', 'El Plan de Entrenamiento de 30 minutos (Solo 3 veces por semana).', 'El Checklist Maestro de Implementación Diaria para los 21 días.', 'Glosario de Optimización y Recursos Estratégicos de Sueño.'];
  return <SectionWrapper className="bg-dark-800 border-y border-white/5" data-id="element-202">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center" data-id="element-203">
        <div className="order-2 lg:order-1 relative" data-id="element-204">
          <div className="absolute inset-0 bg-gold-500/10 blur-[100px] rounded-full z-0" data-id="element-205"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9h8seUYueD9nPUJzA8E2d7/portada_hombre_apagado_nunca_mas.png" alt="Contenido del Protocolo" className="w-full max-w-md mx-auto relative z-10 drop-shadow-2xl" data-id="element-206" />
        </div>

        <div className="order-1 lg:order-2" data-id="element-207">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-10" data-id="element-208">
            Qué vas a <span className="text-gold-500" data-id="element-209">recibir</span>
          </h2>

          <div className="space-y-6" data-id="element-210">
            {items.map((item, idx) => <div key={idx} className="flex gap-4 items-start bg-dark-900/50 p-4 rounded-lg border border-white/5" data-id="element-211">
                <CheckCircle2 className="w-6 h-6 text-gold-500 shrink-0 mt-0.5" data-id="element-212" />
                <p className="text-zinc-300 text-lg" data-id="element-213">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
};